import { render, staticRenderFns } from "./FadeHeightTransition.vue?vue&type=template&id=07f86ced"
import script from "./FadeHeightTransition.vue?vue&type=script&lang=js"
export * from "./FadeHeightTransition.vue?vue&type=script&lang=js"
import style0 from "./FadeHeightTransition.vue?vue&type=style&index=0&id=07f86ced&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports